<template>
  <v-sheet rounded="lg">
    <v-container>
      <h1>Zeitvorlagen</h1>
      <v-list color="transparent">
        <v-list-item-group v-model="selected" color="primary">
          <v-list-item v-for="(template, i) in templates" :key="i" link>
            <v-list-item-content>
              <v-list-item-title
                >{{ template.summary }}
                <v-icon class="float-right" @click.stop="change(i)">mdi-calendar-edit</v-icon>
                <!-- <v-icon class="float-right" @click.stop="delete(i)">mdi-delete</v-icon> -->
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <v-divider class="my-2"></v-divider>
        <v-list-item link color="grey lighten-4">
          <v-list-item-content>
            <v-list-item-title @click="create()">
              Vorlage hinzufügen <v-icon class="float-right">mdi-calendar-plus</v-icon>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  name: "TemplateList",
  props: ["templates"],
  data: function () {
    return { selected: null };
  },
  watch: {
    selected: function (index) {
      this.$emit("use-template", this.templates[index]);
    },
  },
  methods: {
    create: function () {
      this.$emit("create-template");
    },
    change: function (index) {
      this.$emit("change-template", index);
    },
  },
};
</script>

<style></style>
